import React from 'react';
import { useField } from 'formik';
import TextInput from '@atoms/TextInput';

const EditProfileTitle = () => {
    const [studentField] = useField('studentMember');

    return <TextInput label="Job Title" name="title" required disabled={studentField.value} />;
};

export default EditProfileTitle;
